import type { AnalyticsSharedVars } from '~/services/analytics/events-names.ts';
import { track } from '~/services/analytics/index.client.ts';

export type PlayerTrackData = AnalyticsSharedVars & {
  name: string;
  media_id: string;
  media_type: string;
  duration?: number;
  stream_format?: string;
  stream_type?: string;
  free_or_paid?: string;
  analyticsCustomProperties?: string;
};

export const trackPlayerSessionStart = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_session_start', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerSessionEnd = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_session_end', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerPlay = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_play', { ...trackData, current_position: currentPosition });
};

export const trackPlayerPause = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_pause', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerError = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_error', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerBufferStart = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_buffer_start', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerBufferComplete = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_buffer_complete', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerSeekStart = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_seek_start', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerSeekComplete = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_seek_complete', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerClosed = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_closed', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerPresented = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_presented', {
    ...trackData,
    current_position: currentPosition,
  });
};

export const trackPlayerComplete = (
  trackData: PlayerTrackData,
  currentPosition: number
) => {
  track('player_complete', {
    ...trackData,
    current_position: currentPosition,
  });
};
